import React, { useEffect, useState } from "react";
//Toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//bootstrap
import { Button, Col, Row } from "react-bootstrap";
//css
import "./HomePage.css";
//Fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
//components
import ExpensesTable from "../../Components/Expenses/ExpensesTable";
import IncomeTable from "../../Components/Income/IncomeTable";
import PotentialExpensesTable from "../../Components/PotentialExpenses/PotentialExpensesTable";
import PotentialIncomeTable from "../../Components/PotentialIncome/PotentialIncomeTable";
import TotalsTable from "../../Components/Totals/TotalsTable";
import FileSaver from "file-saver";
import CashBalance from "../../Components/CashBalance/CashBalance";
import ImportData from "../../Components/ImportData/ImportData";
import SaveData from "../../Components/SaveData/SaveData";
import DataGraph from "../../Components/DataGraph/DataGraph";

const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const d = new Date();

export default function HomePage() {
  var data = {
    startMonth: undefined,
    startBalance: undefined,
    incomes: [],
    potentialIncomes: [],
    expenses: [],
    potentialExpenses: [],
  };

  const [month1, setMonth1] = useState(month[d.getMonth()]);
  const [month2, setMonth2] = useState(
    month[month.indexOf(month1) + 1] || "January"
  );
  const [month3, setMonth3] = useState(
    month[month.indexOf(month2) + 1] || "January"
  );
  const [month4, setMonth4] = useState(
    month[month.indexOf(month3) + 1] || "January"
  );
  const [month5, setMonth5] = useState(
    month[month.indexOf(month4) + 1] || "January"
  );
  const [month6, setMonth6] = useState(
    month[month.indexOf(month5) + 1] || "January"
  );
  const [month7, setMonth7] = useState(
    month[month.indexOf(month6) + 1] || "January"
  );
  const [month8, setMonth8] = useState(
    month[month.indexOf(month7) + 1] || "January"
  );
  const [month9, setMonth9] = useState(
    month[month.indexOf(month8) + 1] || "January"
  );
  const [month10, setMonth10] = useState(
    month[month.indexOf(month9) + 1] || "January"
  );
  const [month11, setMonth11] = useState(
    month[month.indexOf(month10) + 1] || "January"
  );
  const [month12, setMonth12] = useState(
    month[month.indexOf(month11) + 1] || "January"
  );

  const [tableHeads, setTableHeads] = useState({
    month0: month1,
    month1: month2,
    month2: month3,
    month3: month4,
    month4: month5,
    month5: month6,
    month6: month7,
    month7: month8,
    month8: month9,
    month9: month10,
    month10: month11,
    month11: month12,
  });

  const [incomesData, setIncomesData] = useState([]);
  const [expensesData, setExpensesData] = useState([]);
  const [cashBalanceData, setCashBalanceData] = useState([]);
  const [potentialBalanceData, setPotentialBalanceData] = useState([]);
  const [startBalance, setStartBalance] = useState(0);
  const [show, setShow] = useState(true);
  const [labels, setLabels] = useState([]);

  const [incomeRows, setIncomeRows] = useState([
    {
      id: "0i123",
      title: "",
      incomeOne: 0,
      incomeTwo: 0,
      incomeThree: 0,
      incomeFour: 0,
      incomeFive: 0,
      incomeSix: 0,
      incomeSeven: 0,
      incomeEight: 0,
      incomeNine: 0,
      incomeTen: 0,
      incomeEleven: 0,
      incomeTwelve: 0,
    },
  ]);
  const [incomes, setIncomes] = useState({
    month1: 0,
    month2: 0,
    month3: 0,
    month4: 0,
    month5: 0,
    month6: 0,
    month7: 0,
    month8: 0,
    month9: 0,
    month10: 0,
    month11: 0,
    month12: 0,
  });

  const [potentialIncomeRows, setPotentialIncomeRows] = useState([
    {
      id: "0x123",
      title: "",
      potentialIncomeOne: 0,
      potentialIncomeTwo: 0,
      potentialIncomeThree: 0,
      potentialIncomeFour: 0,
      potentialIncomeFive: 0,
      potentialIncomeSix: 0,
      potentialIncomeSeven: 0,
      potentialIncomeEight: 0,
      potentialIncomeNine: 0,
      potentialIncomeTen: 0,
      potentialIncomeEleven: 0,
      potentialIncomeTwelve: 0,
    },
  ]);
  const [potentialIncomes, setPotentialIncomes] = useState({
    month1: 0,
    month2: 0,
    month3: 0,
    month4: 0,
    month5: 0,
    month6: 0,
    month7: 0,
    month8: 0,
    month9: 0,
    month10: 0,
    month11: 0,
    month12: 0,
  });

  const [expenseRows, setExpenseRows] = useState([
    {
      id: "0e123",
      title: "",
      expenseOne: 0,
      expenseTwo: 0,
      expenseThree: 0,
      expenseFour: 0,
      expenseFive: 0,
      expenseSix: 0,
      expenseSeven: 0,
      expenseEight: 0,
      expenseNine: 0,
      expenseTen: 0,
      expenseEleven: 0,
      expenseTwelve: 0,
    },
  ]);
  const [expenses, setExpenses] = useState({
    month1: 0,
    month2: 0,
    month3: 0,
    month4: 0,
    month5: 0,
    month6: 0,
    month7: 0,
    month8: 0,
    month9: 0,
    month10: 0,
    month11: 0,
    month12: 0,
  });

  const [potentialExpenseRows, setPotentialExpenseRows] = useState([
    {
      id: "0z123",
      title: "",
      potentialExpenseOne: 0,
      potentialExpenseTwo: 0,
      potentialExpenseThree: 0,
      potentialExpenseFour: 0,
      potentialExpenseFive: 0,
      potentialExpenseSix: 0,
      potentialExpenseSeven: 0,
      potentialExpenseEight: 0,
      potentialExpenseNine: 0,
      potentialExpenseTen: 0,
      potentialExpenseEleven: 0,
      potentialExpenseTwelve: 0,
    },
  ]);
  const [potentialExpenses, setPotentialExpenses] = useState({
    month1: 0,
    month2: 0,
    month3: 0,
    month4: 0,
    month5: 0,
    month6: 0,
    month7: 0,
    month8: 0,
    month9: 0,
    month10: 0,
    month11: 0,
    month12: 0,
  });

  const [profits, setProfits] = useState({
    month1: 0,
    month2: 0,
    month3: 0,
    month4: 0,
    month5: 0,
    month6: 0,
    month7: 0,
    month8: 0,
    month9: 0,
    month10: 0,
    month11: 0,
    month12: 0,
  });
  const [cashBalance, setCashBalance] = useState({
    month1: 0,
    month2: 0,
    month3: 0,
    month4: 0,
    month5: 0,
    month6: 0,
    month7: 0,
    month8: 0,
    month9: 0,
    month10: 0,
    month11: 0,
    month12: 0,
  });
  const [potentialCashBalance, setPotentialCashBalance] = useState({
    month1: 0,
    month2: 0,
    month3: 0,
    month4: 0,
    month5: 0,
    month6: 0,
    month7: 0,
    month8: 0,
    month9: 0,
    month10: 0,
    month11: 0,
    month12: 0,
  });

  const deleteMonth = (monthIndex) => {
    var finalMonthSplit = tableHeads.month11.split(" ");

    if (monthIndex === 0) {
      setTableHeads({
        month0: tableHeads.month1,
        month1: tableHeads.month2,
        month2: tableHeads.month3,
        month3: tableHeads.month4,
        month4: tableHeads.month5,
        month5: tableHeads.month6,
        month6: tableHeads.month7,
        month7: tableHeads.month8,
        month8: tableHeads.month9,
        month9: tableHeads.month10,
        month10: tableHeads.month11,
        month11:
          month[month.indexOf(finalMonthSplit[0]) + 1] === undefined
            ? "January "
            : month[month.indexOf(finalMonthSplit[0]) + 1],
      });
      incomeRows.map((Row) => {
        let current = incomeRows.find((row) => row.id === Row.id);
        if (current) {
          current.incomeOne = current.incomeTwo || "";
          current.incomeTwo = current.incomeThree || "";
          current.incomeThree = current.incomeFour || "";
          current.incomeFour = current.incomeFive || "";
          current.incomeFive = current.incomeSix || "";
          current.incomeSix = current.incomeSeven || "";
          current.incomeSeven = current.incomeEight || "";
          current.incomeEight = current.incomeNine || "";
          current.incomeNine = current.incomeTen || "";
          current.incomeTen = current.incomeEleven || "";
          current.incomeEleven = current.incomeTwelve || "";
          current.incomeTwelve = "";

          setIncomeRows([...incomeRows]);
        }
      });
      potentialIncomeRows.map((Row) => {
        let current = potentialIncomeRows.find((row) => row.id === Row.id);
        if (current) {
          current.potentialIncomeOne = current.potentialIncomeTwo || "";
          current.potentialIncomeTwo = current.potentialIncomeThree || "";
          current.potentialIncomeThree = current.potentialIncomeFour || "";
          current.potentialIncomeFour = current.potentialIncomeFive || "";
          current.potentialIncomeFive = current.potentialIncomeSix || "";
          current.potentialIncomeSix = current.potentialIncomeSeven || "";
          current.potentialIncomeSeven = current.potentialIncomeEight || "";
          current.potentialIncomeEight = current.potentialIncomeNine || "";
          current.potentialIncomeNine = current.potentialIncomeTen || "";
          current.potentialIncomeTen = current.potentialIncomeEleven || "";
          current.potentialIncomeEleven = current.potentialIncomeTwelve || "";
          current.potentialIncomeTwelve = "";

          setPotentialIncomeRows([...potentialIncomeRows]);
        }
      });
      expenseRows.map((Row) => {
        let current = expenseRows.find((row) => row.id === Row.id);
        if (current) {
          current.expenseOne = current.expenseTwo || "";
          current.expenseTwo = current.expenseThree || "";
          current.expenseThree = current.expenseFour || "";
          current.expenseFour = current.expenseFive || "";
          current.expenseFive = current.expenseSix || "";
          current.expenseSix = current.expenseSeven || "";
          current.expenseSeven = current.expenseEight || "";
          current.expenseEight = current.expenseNine || "";
          current.expenseNine = current.expenseTen || "";
          current.expenseTen = current.expenseEleven || "";
          current.expenseEleven = current.expenseTwelve || "";
          current.expenseTwelve = "";

          setExpenseRows([...expenseRows]);
        }
      });
      potentialExpenseRows.map((Row) => {
        let current = potentialExpenseRows.find((row) => row.id === Row.id);
        if (current) {
          current.potentialExpenseOne = current.potentialExpenseTwo || "";
          current.potentialExpenseTwo = current.potentialExpenseThree || "";
          current.potentialExpenseThree = current.potentialExpenseFour || "";
          current.potentialExpenseFour = current.potentialExpenseFive || "";
          current.potentialExpenseFive = current.potentialExpenseSix || "";
          current.potentialExpenseSix = current.potentialExpenseSeven || "";
          current.potentialExpenseSeven = current.potentialExpenseEight || "";
          current.potentialExpenseEight = current.potentialExpenseNine || "";
          current.potentialExpenseNine = current.potentialExpenseTen || "";
          current.potentialExpenseTen = current.potentialExpenseEleven || "";
          current.potentialExpenseEleven = current.potentialExpenseTwelve || "";
          current.potentialExpenseTwelve = "";

          setPotentialExpenseRows([...potentialExpenseRows]);
        }
      });
    }
  };

  useEffect(() => {
    setProfits({
      month1: incomes.month1 - expenses.month1,
      month2: incomes.month2 - expenses.month2,
      month3: incomes.month3 - expenses.month3,
      month4: incomes.month4 - expenses.month4,
      month5: incomes.month5 - expenses.month5,
      month6: incomes.month6 - expenses.month6,
      month7: incomes.month7 - expenses.month7,
      month8: incomes.month8 - expenses.month8,
      month9: incomes.month9 - expenses.month9,
      month10: incomes.month10 - expenses.month10,
      month11: incomes.month11 - expenses.month11,
      month12: incomes.month12 - expenses.month12,
    });
  }, [incomes, expenses]);

  useEffect(() => {
    setIncomesData([]);
    setExpensesData([]);
    setCashBalanceData([]);
    setPotentialBalanceData([]);

    Object.keys(incomes).map((incomeItem) => {
      setIncomesData((prev) => {
        return [...prev, incomes[incomeItem]];
      });
    });

    Object.keys(expenses).map((expenseItem) => {
      setExpensesData((prev) => {
        return [...prev, expenses[expenseItem]];
      });
    });

    Object.keys(cashBalance).map((cashBalanceItem) => {
      setCashBalanceData((prev) => {
        return [...prev, cashBalance[cashBalanceItem]];
      });
    });

    Object.keys(potentialCashBalance).map((potentialBalanceItem) => {
      setPotentialBalanceData((prev) => {
        return [...prev, potentialCashBalance[potentialBalanceItem]];
      });
    });
  }, [incomes, expenses, cashBalance, potentialCashBalance]);

  useEffect(() => {
    var arr = [];
    Object.keys(tableHeads).map((month) => {
      arr = [...arr, tableHeads[month]];
    });
    setLabels([...arr]);
  }, [tableHeads]);

  const Save = () => {
    data.startMonth = month1;
    data.startBalance = startBalance;
    data.incomes = incomeRows;
    data.potentialIncomes = potentialIncomeRows;
    data.expenses = expenseRows;
    data.potentialExpenses = potentialExpenseRows;

    var output = JSON.stringify(data);
    var blob = new Blob([output], {
      type: "text/plain;charset=utf-8",
    });
    FileSaver.saveAs(blob, "FinancialForecast.txt");
  };

  const showToastError = (ErrorMessage) => {
    toast.error(ErrorMessage, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const Load = (e) => {
    const file = e.target.files[0];
    var fileData = null;
    if (file) {
      if (file.type === "text/plain") {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = () => {
          try {
            fileData = JSON.parse(reader.result);
          } catch (error) {
            e.target.value = null;
            fileData = "invalid";
          }

          if (fileData !== "invalid") {
            if (
              fileData.startMonth &&
              fileData.expenses &&
              fileData.incomes &&
              fileData.potentialIncomes &&
              fileData.potentialExpenses
            ) {
              setIncomeRows(fileData.incomes);
              setExpenseRows(fileData.expenses);
              setPotentialIncomeRows(fileData.potentialIncomes);
              setPotentialExpenseRows(fileData.potentialExpenses);
              setMonth1(fileData.startMonth);
              setStartBalance(fileData.startBalance);
            } else {
              e.target.value = null;
              showToastError("Invalid File");
            }
          } else {
            e.target.value = null;
            showToastError("Invalid File");
          }
        };
        reader.onerror = () => {
          console.log("error: ", reader.error);
        };
      } else {
        e.target.value = null;
        showToastError("Invalid File");
      }
    }
  };

  useEffect(() => {
    setMonth2(month[month.indexOf(month1) + 1] || "January");
    setMonth3(month[month.indexOf(month2) + 1] || "January");
    setMonth4(month[month.indexOf(month3) + 1] || "January");
    setMonth5(month[month.indexOf(month4) + 1] || "January");
    setMonth6(month[month.indexOf(month5) + 1] || "January");
    setMonth7(month[month.indexOf(month6) + 1] || "January");
    setMonth8(month[month.indexOf(month7) + 1] || "January");
    setMonth9(month[month.indexOf(month8) + 1] || "January");
    setMonth10(month[month.indexOf(month9) + 1] || "January");
    setMonth11(month[month.indexOf(month10) + 1] || "January");
    setMonth12(month[month.indexOf(month11) + 1] || "January");
    updateTableHeads();
  }, [
    month1,
    month2,
    month3,
    month4,
    month5,
    month6,
    month7,
    month8,
    month9,
    month10,
    month11,
    month12,
  ]);

  const updateTableHeads = () => {
    setTableHeads({
      month0: month1,
      month1: month2,
      month2: month3,
      month3: month4,
      month4: month5,
      month5: month6,
      month6: month7,
      month7: month8,
      month8: month9,
      month9: month10,
      month10: month11,
      month11: month12,
    });
  };

  return (
    <div>
      <div className="mb-2">
        <div>
          <Row className="mt-2 card shadow g-0">
            <Col className="col-5 graphCard ">
              <DataGraph
                incomesData={incomesData}
                expensesData={expensesData}
                cashBalanceData={cashBalanceData}
                potentialBalanceData={potentialBalanceData}
                labels={labels}
                tableHeads={tableHeads}
              />
            </Col>
          </Row>
        </div>
        {show && (
          <div className="alignCentre p-2 mt-3">
            <Row className="g-0">
              <Col className="col-1"></Col>
              <Col className="">
                <CashBalance
                  startBalance={startBalance}
                  setStartBalance={setStartBalance}
                />
              </Col>
              <Col className="col-1"></Col>
              <Col className="col-2">
                <SaveData Save={Save} />
              </Col>
              <Col className="col-1"></Col>
              <Col className="">
                <ImportData Load={Load} />
              </Col>
              <Col className="col-1">
                <Button
                  onClick={() => {
                    setShow(!show);
                  }}
                  type="button"
                  className="saveButton hideButton"
                >
                  <FontAwesomeIcon className="black" icon={faEyeSlash} />
                </Button>
              </Col>
            </Row>
          </div>
        )}
        {!show && (
          <Row className="hide me-3 alignCentre">
            <Col className="col-11"> </Col>
            <Col className="col-1">
              <Button
                onClick={() => {
                  setShow(!show);
                }}
                type="button"
                className="saveButton"
              >
                <FontAwesomeIcon className="black" icon={faEye} />
              </Button>
            </Col>
          </Row>
        )}
        <div className="p-2  mt-1">
          <IncomeTable
            incomes={incomes}
            setIncomes={setIncomes}
            incomeRows={incomeRows}
            setIncomeRows={setIncomeRows}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
          />
        </div>
        <div className="p-2  mt-1">
          <PotentialIncomeTable
            potentialIncomes={potentialIncomes}
            setPotentialIncomes={setPotentialIncomes}
            potentialIncomeRows={potentialIncomeRows}
            setPotentialIncomeRows={setPotentialIncomeRows}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
          />
        </div>
        <div className="p-2  mt-1">
          <ExpensesTable
            expenses={expenses}
            setExpenses={setExpenses}
            expenseRows={expenseRows}
            setExpenseRows={setExpenseRows}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
          />
        </div>
        <div className="p-2  mt-1">
          <PotentialExpensesTable
            potentialExpenses={potentialExpenses}
            setPotentialExpenses={setPotentialExpenses}
            potentialExpenseRows={potentialExpenseRows}
            setPotentialExpenseRows={setPotentialExpenseRows}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
          />
        </div>
        <div className="p-2  mt-1">
          <TotalsTable
            incomes={incomes}
            expenses={expenses}
            profits={profits}
            potentialIncomes={potentialIncomes}
            potentialExpenses={potentialExpenses}
            startBalance={startBalance}
            cashBalance={cashBalance}
            setCashBalance={setCashBalance}
            potentialCashBalance={potentialCashBalance}
            setPotentialCashBalance={setPotentialCashBalance}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
          />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
